import { Injectable } from '@angular/core';
import { delay, Observable, of } from 'rxjs';
import { fillArr } from '@pin-up-global/common';
import { ApiService, ListResponse } from '@shared/abstraction';
import { manageLoadingStatus } from '@shared/rxjs-operators';
import { BotUser, BotUserStatus } from '@shared/bot-user';
import { ChangeUserStatusReq, UsersReq } from './users.abstraction';

@Injectable()
export class UsersApiServiceMock extends ApiService {
  isLoading$ = this._isLoading$;

  getUsers(params: UsersReq): Observable<ListResponse<BotUser>> {
    return of({
      items: fillArr(params.limit!, id => ({
        id,
        botId: params.botId,
        platformId: 1,
        email: `jon_snow${ id }@email`,
        firstName: `Jon ${ id * params.page! }`,
        lastName: `Snow ${ id * params.page! }`,
        username: `jon_snow ${ id * params.page! }`,
        status: id % 2 === 1 ? BotUserStatus.Subscribed : BotUserStatus.Disabled,
        phoneNumber: '+1 123 456 7890',
        preferredLocaleId: 1,
        createdAt: '2024-09-03T10:49:28.927000Z',
        updatedAt: '2024-09-03T10:49:28.927000Z',
        lastActiveAt: '2024-09-03T10:49:28.927000Z',
        authorizedAt: '2024-09-03T10:49:28.927000Z',
      })),
      count: 100,
    }).pipe(
        delay(1000),
        manageLoadingStatus(this._isLoadingMap, this._isLoadingMap$),
    );
  }

  blockUnblockUser(params: ChangeUserStatusReq): Observable<BotUser> {
    const { userId, status } = params;
    return of({
        id: userId,
        botId: 1,
        platformId: 1,
        email: `jon_snow${ userId }@email`,
        firstName: `Jon ${ userId }`,
        lastName: `Snow ${ userId }`,
        username: `jon_snow ${ userId }`,
        status,
        phoneNumber: '+1 123 456 7890',
        preferredLocaleId: 1,
        createdAt: '2024-09-03T10:49:28.927000Z',
        updatedAt: '2024-09-03T10:49:28.927000Z',
        lastActiveAt: '2024-09-03T10:49:28.927000Z',
        authorizedAt: '2024-09-03T10:49:28.927000Z',
    }).pipe(
        delay(1000),
        manageLoadingStatus(this._isLoadingMap, this._isLoadingMap$),
    );
  }
}
